<template>
  <div class="bidi-zone">
    <loading-indicator v-if="loadingRegistrationSnippets" mode="sm" class="mt-4" />
    <template v-else>
      <h1 v-if="configuration.registrationPageTitle" class="onboarding-title">
        {{ configuration.registrationPageTitle }}
      </h1>
      <div
        ref="contentContainer"
        :style="{ 'max-height': `${maxUnfoldedLinesCount * lineHeightInRem}rem`, 'line-height': `${lineHeightInRem}rem` }"
        class="introduction-content color-post-detail bidi-auto"
        :class="{ 'show-whole-content': !folded }"
      >
        {{ configuration.registrationPageIntroduction }}
      </div>
      <the-button v-if="folded" text small custom-colors class="mt-n1 ml-n2 color-post-text" @click="folded = false">
        {{ $translate("OnboardingDescriptions.readMore") }}
      </the-button>
    </template>
  </div>
</template>

<script>
import { mapState } from "pinia"
import { useConfigurationStore } from "@/store/configuration.js"

import * as styles from "@/services/styles.js"

export default {
  data() {
    return {
      maxUnfoldedLinesCount: 2,
      lineHeightInRem: 1.5,
      folded: false
    }
  },
  computed: {
    ...mapState(useConfigurationStore, ["configuration", "loadingRegistrationSnippets"])
  },
  mounted() {
    this.foldOrUnfoldPostText()
  },
  methods: {
    foldOrUnfoldPostText() {
      if (!this.$refs.contentContainer) {
        return
      }

      this.folded = this.$refs.contentContainer.scrollHeight > styles.remToPixels(this.lineHeightInRem * this.maxUnfoldedLinesCount) + 1
    }
  }
}
</script>

<style lang="scss" scoped>
.introduction-content {
  overflow: hidden;
  white-space: pre-wrap;

  &.show-whole-content {
    overflow: visible;
    max-height: none !important;
  }
}
</style>
